//Reset doesn't have any reducer for now, it only holds the action type to allow reseting other reducers

// Actions
export const RESET_ACTIVITY = "reset/activity/RESET";

// Action creators

export function reset(id) {
  return { type: RESET_ACTIVITY, id };
}
